import DiscoveryFeatureCard from './DiscoveryFeatureCard.component';

export default DiscoveryFeatureCard;
